export function setErrors(errors, form) {
  for (const error in errors) {
    const errorBlock = form.querySelector(`[data-key="${error}"]`);
    if (errorBlock) {
      errorBlock.insertAdjacentHTML(
        "afterend",
        `<span class="error-message">${errors[error]}</span>`
      );
    }
  }
}
